<template>
  <div class="card">
    <!-- {{item}} -->

    <img class="store" :src="item.image" />

    <div class="carddDistance text-center">
      <span v-if="item.ratings.avg_rating > 0"
        >{{ item.ratings.avg_rating }} <i class="fa fa-star"></i></span
      ><br />
      <span class="listStoreDistance">
        <!-- <img src="/img/newlocaiton.png" class="img-fluid" alt=""> -->
        {{ item.distance }} km <span class="forDesktop">away</span>
      </span>
    </div>
  </div>
</template>
<style scoped>
.listStoreDistance {
  font-size: 12px;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: #ffffff;
  width: 225px;
  min-height: 225px;
  margin: 17px;
  border-radius: 12px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
}
.carddDistance {
  position: absolute;
  bottom: 20px;
  color: #ffffff;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.card:hover .carddDistance {
  opacity: 1;
}
.card:hover {
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  /* transform: scale(1.1); */
  transition: all 250ms ease-in-out;
}

.store {
  width: 100%;
  max-width: 200px;
}
/* Responsive  */
@media screen and (max-width: 767px) {
  .carddDistance {
    bottom: 10px;
    font-size: 12px;
  }
  .card {
    flex-direction: row !important;
    justify-content: center;
    align-items: center;
    padding: 0 20px !important;
    width: 100%;
    max-width: 123px;
    /* min-width: 123px; */
    min-height: 125px;
    margin: 2% auto;
    /* padding: 1rem; */
  }
  .store {
    width: 100%;
    max-width: 100px;
    overflow: hidden;
  }
}
</style>
<script>
export default {
  props: ["item"],
  //  created(){
  //      console.log(this.item);
  //  }
};
</script>